import React from 'react';
import { useFormState } from 'react-final-form';
import PropTypes from 'prop-types';
import { CheckboxesField } from '../../01_atoms/FormElements';
import { DEFAULT_CURRENCY, formatAmount } from '../../../utils/currency';
import Tooltip from '../../01_atoms/Tooltip';

import styles from './index.module.scss';

const FundraisingCosts = ({ tooltipText = '' }) => {
  const formState = useFormState();
  const costsAmount = formState.values.fundraisingCostsAmount;
  return (
    <div className={styles['fundraising-costs']}>
      <CheckboxesField
        name="fundraising_costs"
        options={[
          {
            value: 'fundraising_costs',
            label: `Add ${formatAmount(DEFAULT_CURRENCY, costsAmount)} to help cover our`,
          },
        ]}
        label=""
      />
      <Tooltip
        content={
          tooltipText
            ? tooltipText
            : 'Adding this small percentage helps us cover the cost of this transaction'
        }
      >
        payment provider costs
      </Tooltip>
    </div>
  );
};

FundraisingCosts.propTypes = {
  tooltipText: PropTypes.string,
};

export default FundraisingCosts;
